<template>
    <div>
        <loading :active.sync="loadingApp" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link to="/" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Transaksi</div>
            <div class="right">
                <a class="headerButton" @click="refresh()">
                    <ion-icon name="sync-sharp"></ion-icon>
                </a>
                
            </div>
        </div>
        <!-- * App Header -->

        <!-- Extra Header -->
        <div class="extraHeader bg-primary pr-0 pl-0">
            <ul class="nav nav-tabs lined" role="tablist">
                <li class="nav-item">
                    <a class="nav-link" :class="{'active': ComponentPrabayar == true}" @click="showComponentPrabayar">
                        Prabayar
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" :class="{'active': ComponentPascabayar == true}" @click="showComponentPascabayar">
                        Pascabayar
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" :class="{'active': ComponentDeposit == true}" @click="showComponentDeposit">
                        Deposit
                    </a>
                </li>
            </ul>
        </div>
        <!-- * Extra Header -->

        <div id="appCapsule" class="extra-header-active">
            <!-- Transactions -->
            <div class="section full tab-content mb-2 mt-1">
                <!-- Prabayar tab -->
                <div class="tab-pane" :class="{'show active': ComponentPrabayar == true}">
                    <ComponentPrabayar :data="prabayar" :loadingButton="loadingButton" :loadingApp="loadingApp" @paginate="paginatePrabayar(prabayar.next_page_url)">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <input type="number" class="form-control" placeholder="Cari transaksi" v-model="prabayar.keywords" @input="eventSearchPrabayar('search')">
                                <i class="clear-input" @click="eventSearchPrabayar('clear')">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                    </ComponentPrabayar>
                </div>
                <!-- * Prabayar tab -->

                <!-- Pascabayar tab -->
                <div class="tab-pane" :class="{'show active': ComponentPascabayar == true}">
                    <ComponentPascabayar :data="pascabayar" :loadingButton="loadingButton" :loadingApp="loadingApp" @paginate="paginatePascabayar(pascabayar.next_page_url)">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <input type="number" class="form-control" placeholder="Cari transaksi" v-model="pascabayar.keywords" @input="eventSearchPascabayar('search')">
                                <i class="clear-input" @click="eventSearchPascabayar('clear')">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                    </ComponentPascabayar>
                </div>
                <!-- * Pascabayar tab -->
                
                <!-- Deposit tab -->
                <div class="tab-pane" :class="{'show active': ComponentDeposit == true}">
                    <ComponentDeposit :data="deposit" :loadingButton="loadingButton" :loadingApp="loadingApp" @paginate="paginateDeposit(deposit.next_page_url)">
                        <!-- <div class="form-group basic">
                            <div class="input-group">
                                <span class="input-group-text"><ion-icon name="search-outline"></ion-icon></span>
                                <input type="number" class="form-control" placeholder="Cari Nominal" v-model="deposit.keywords" @input="searchDeposit">
                                
                            </div>
                        </div> -->
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <input type="number" class="form-control" placeholder="Cari transaksi" v-model="deposit.keywords" @input="eventSearchDeposit('search')">
                                <i class="clear-input" @click="eventSearchDeposit('clear')">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                        </div>
                    </ComponentDeposit>
                </div>
                <!-- * Deposit tab -->
            </div>
            <!-- * Transactions -->
        </div>
    </div>
</template>
<script>
import moment from 'moment'
moment.locale('id')
import $axios from './../../api.js'
import ComponentPrabayar from './prabayar/Index'
import ComponentPascabayar from './pascabayar/Index'
import ComponentDeposit from './deposit/Index'
import { mapState } from 'vuex'
export default {
    name: 'Referral',
    components:{
        ComponentPrabayar,
        ComponentPascabayar,
        ComponentDeposit
    },
    data() {
        return {
            ComponentPrabayar: false,
            ComponentPascabayar: false,
            ComponentDeposit: false,
            prabayar: {
                data: [],
                keywords: ''
            },
            pascabayar:{
                data: [],
                keywords: ''
            },
            deposit:{
                data: [],
                keywords: ''
            },
            loadingApp: true,
            loadingButton: false
        }
    },
    created() {
        this.ComponentPrabayar = true
        this.paginatePrabayar()
        
    },
    computed: {
        ...mapState(['toast']),
    },
    methods: {
        showComponentPrabayar(){
            if(this.ComponentPrabayar == false){
                this.ComponentPrabayar = true
                this.ComponentPascabayar = false
                this.ComponentDeposit = false
                this.loadingApp = true
                this.prabayar = {
                    data: [],
                    keywords: ''
                }
                this.RESET_LOADING()
                this.paginatePrabayar()
            }
        },
        showComponentPascabayar(){
            if(this.ComponentPascabayar == false){
                this.ComponentPascabayar = true
                this.ComponentPrabayar = false
                this.ComponentDeposit = false
                this.pascabayar = {
                    data: [],
                    keywords: ''
                }
                this.RESET_LOADING()
                this.paginatePascabayar()
            }
        },
        showComponentDeposit(){
            if(this.ComponentDeposit == false){
                this.ComponentDeposit = true
                this.ComponentPrabayar = false
                this.ComponentPascabayar = false
                this.deposit = {
                    data: [],
                    keywords: ''
                }
                this.RESET_LOADING()
                this.paginateDeposit()
            }
        },
        
        paginatePrabayar(url = ''){
            this.loadingButton = true
            $axios.get(url ? url:'/transaction/prabayar', {
                params:{
                    keywords: this.prabayar.keywords
                }
            })
            .then(response => {
                if(!this.prabayar.data){
                    this.prabayar = response.data.data
                }else{
                    this.prabayar.data.push(...response.data.data.data)
                    this.prabayar.next_page_url = response.data.data.next_page_url
                }
                this.loadingButton = false
                this.loadingApp = false
            }).catch(() => {
                this.loadingButton = false
                this.loadingApp = false
            })
        },
        paginatePascabayar(url = ''){
            this.loadingButton = true
            $axios.get(url ? url:'/transaction/pascabayar', {
                params:{
                    keywords: this.pascabayar.keywords
                }
            })
            .then(response => {
                if(!this.pascabayar.data){
                    this.pascabayar = response.data.data
                }else{
                    this.pascabayar.data.push(...response.data.data.data)
                    this.pascabayar.next_page_url = response.data.data.next_page_url
                }
                this.loadingButton = false
                this.loadingApp = false
            }).catch(() => {
                this.loadingButton = false
                this.loadingApp = false
            })
        },
        paginateDeposit(url = ''){
            this.loadingButton = true
            $axios.get(url ? url:'/transaction/deposit',{
                params:{
                    keywords: this.deposit.keywords
                }
            })
            .then(response => {
                if(!this.deposit.data){
                    this.deposit = response.data.data
                }else{
                    this.deposit.data.push(...response.data.data.data)
                    this.deposit.next_page_url = response.data.data.next_page_url
                }
                this.loadingButton = false
                this.loadingApp = false
            }).catch(() => {
                this.loadingButton = false
                this.loadingApp = false
            })
        },
        
        // Function Search Prabayar Data
        searchPrabayar(keywords, second){
            if(this.time){
                clearTimeout(this.time)
            }
            this.time = setTimeout(() => {
                this.loadingApp = true
                this.prabayar = {
                    data: [],
                    keywords: keywords
                }
                this.paginatePrabayar()
            }, second)
        },
        eventSearchPrabayar(value){

            if(value == 'search'){
                this.searchPrabayar(this.prabayar.keywords, 500)
            }else if(value == 'clear'){
                this.searchPrabayar('', 300)
            }
        },

        searchPascabayar(keywords, second){
            if(this.time){
                clearTimeout(this.time)
            }
            this.time = setTimeout(() => {
                this.loadingApp = true
                this.pascabayar = {
                    data: [],
                    keywords: keywords
                }
                this.paginatePascabayar()
            }, second)
        },
        eventSearchPascabayar(value){
            if(value == 'search'){
                this.searchPascabayar(this.pascabayar.keywords, 500)
            }else if(value == 'clear'){
                this.searchPascabayar('', 300)
            }
        },


        searchDeposit(keywords, second){
            if(this.time){
                clearTimeout(this.time)
            }
            this.time = setTimeout(() => {
                this.loadingApp = true
                this.deposit = {
                    data: [],
                    keywords: keywords
                }
                this.paginateDeposit()
            }, second)
        },
        eventSearchDeposit(value){
            if(value == 'search'){
                this.searchDeposit(this.deposit.keywords, 500)
            }else if(value == 'clear'){
                this.searchDeposit('', 300)
            }
        },
        
        refresh(){
            this.loadingApp = true
            if(this.ComponentPrabayar == true){
                this.prabayar = {
                    data: [],
                    keywords: this.prabayar.keywords
                }
                this.paginatePrabayar()
            }else if(this.ComponentPascabayar == true){
                this.pascabayar = {
                    data: []
                }
                this.paginatePascabayar()
            }else{
                this.deposit = {
                    data: []
                }
                this.paginateDeposit()
            }
        },
        RESET_LOADING(){
            this.loadingApp = true
            this.loadingButton = false
        },
    },
}
</script>